export default {
  SUBSCRIPTION_MGMT_REQUEST: 'APP/SUBSCRIPTION_MGMT/SUBSCRIPTION_MGMT_REQUEST',
  SUBSCRIPTION_MGMT_SUCCESS: 'APP/SUBSCRIPTION_MGMT/SUBSCRIPTION_MGMT_SUCCESS',
  SUBSCRIPTION_MGMT_ERROR: 'APP/SUBSCRIPTION_MGMT/SUBSCRIPTION_MGMT_ERROR',
};
